/* Galaxy - back-to-top button + chat ball styling. Global, self-contained (injects its own CSS
   so it needs no extra <link>). Loaded from snippets/galaxy-header-motion.liquid.
   Appears after 600px of scroll; bottom-right; z-index 80 so it sits under the
   cart drawer / any modal.

   2026-10-08: Shopify Inbox chat button restyled as a round ball that matches this button
   (navy, 46px, same shadow). Arrow drawn at the chat icon's size and line weight (19.3px, 1.6 stroke). Desktop: hovering the chat ball slides out the "Chat" label.
   Touch screens: stays a plain circle. The Inbox activator is exposed as
   shopify-chat::part(activator), which is the only supported hook into its shadow DOM.
   The back-to-top button parks directly below the chat ball, centred on it, and follows
   wherever Inbox puts its button (offsets differ with the admin preview bar / phone).

   2026-10-09: dock() uses clientWidth so the balls line up on Windows (visible scrollbar).
   2026-10-13: button sits in a fixed inset:0 layer placed from the chat ball's CSS offsets; see dock().
   2026-10-21: all sizes in px, never rem. Dawn's rem follows the browser's default font size,
   so on a Mac/PC with larger text the arrow ball grew (57.5px) while the chat ball stayed 46px.
   Both balls are now fixed 46px (42px on phones) whatever the text-size setting.

   NOTE: deliberately does NOT use requestAnimationFrame to throttle the scroll
   handler. rAF is frozen in background/hidden tabs, so the button silently never
   appeared when the page was scripted from a non-focused tab. A timestamp throttle
   behaves the same for users and stays testable. */
(function () {
  if (window.__gxTop) return; window.__gxTop = true;
  var SHOW_AT = 600, GAP = 12, btn = null, last = 0;

  function style(){
    if (document.getElementById('gx-top-style')) return;
    var s = document.createElement('style'); s.id = 'gx-top-style';
    s.textContent =
        '.gx-layer{position:fixed;inset:0;pointer-events:none;z-index:80;}'
      + '.gx-top{position:absolute;pointer-events:auto;right:24px;bottom:28px;z-index:80;width:46px;height:46px;min-width:46px;min-height:46px;padding:0;box-sizing:border-box;'
      + 'display:flex;align-items:center;justify-content:center;border:0;border-radius:50%;cursor:pointer;'
      + 'background:#1B2A78;color:#fff;box-shadow:0 6px 20px rgba(15,23,60,.28);'
      + 'opacity:0;visibility:hidden;transform:translateY(10px);'
      + 'transition:opacity .22s ease,transform .22s ease,visibility .22s,background .18s ease;}'
      + '.gx-top.is-on{opacity:1;visibility:visible;transform:none;}'
      + '.gx-top:hover{background:#2E4199;}'
      + '.gx-top:focus-visible{outline:2px solid #F37021;outline-offset:3px;}'
      + '.gx-top svg{width:19.3px;height:19.3px;display:block;}'
      + '@media screen and (max-width:749px){.gx-top{right:14px;bottom:18px;width:42px;height:42px;min-width:42px;min-height:42px;}}'
      + '@media print{.gx-top{display:none;}}'
      /* Inbox chat ball: same size, colour and shadow as .gx-top */
      + 'shopify-chat::part(activator){height:46px;min-height:46px;min-width:46px;max-width:46px;'
      + 'padding:0 0 0 13.37px;font-size:16px;border-radius:999px;overflow:hidden;white-space:nowrap;'
      + 'justify-content:start;column-gap:24px;'
      + 'background-color:#1B2A78;color:#fff;-webkit-backdrop-filter:none;backdrop-filter:none;'
      + 'box-shadow:0 6px 20px rgba(15,23,60,.28);'
      + 'transition:max-width .25s ease,padding .25s ease,column-gap .25s ease,background-color .18s ease;}'
      + '@media (hover:hover) and (pointer:fine){'
      + 'shopify-chat::part(activator):hover{max-width:180px;padding-right:18px;column-gap:10px;background-color:#2E4199;}}'
      + '@media screen and (max-width:749px){shopify-chat::part(activator){height:42px;min-height:42px;min-width:42px;max-width:42px;padding-left:11.37px;}}';
    document.head.appendChild(s);
  }

  /* Find the Inbox chat button (nested open shadow roots). */
  var chatCache = null;
  function chatButton(){
    if (chatCache && chatCache.isConnected) return chatCache;
    var host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return null;
    var found = null;
    (function walk(root){
      var all = root.querySelectorAll('*');
      for (var i = 0; i < all.length && !found; i++) {
        var e = all[i];
        if (e.getAttribute && e.getAttribute('part') === 'activator') { found = e; return; }
        if (e.shadowRoot) walk(e.shadowRoot);
      }
    })(host.shadowRoot);
    chatCache = found;
    return found;
  }

  /* Park the back-to-top button directly below the chat ball, centred on it.
     Falls back to sitting above the ball if there is no room underneath.

     2026-10-13 (v3): no screen measuring at all. Inbox draws the ball inside <shopify-chat>,
     a position:fixed; inset:0 layer, at CSS offsets on .activator-nudge (bottom 148px,
     right 20px on this store). The button now lives in its own fixed inset:0 layer
     (.gx-layer) and is placed from those same CSS numbers, so both layers move together
     however the phone toolbar grows or shrinks. Earlier versions measured
     getBoundingClientRect() and were out of step on phones while scrolling. */
  var appliedKey = '';
  function chatOffsets(){
    var a = chatButton();
    if (!a) return null;
    var box = a.parentElement;
    if (!box) return null;
    var cs = getComputedStyle(box);
    if (cs.position !== 'absolute' && cs.position !== 'fixed') return null;
    var b = parseFloat(cs.bottom), r = parseFloat(cs.right);
    var ball = a.offsetHeight || box.offsetHeight;
    if (isNaN(b) || isNaN(r) || !ball) return null;
    return { bottom: b, right: r, ball: ball };
  }
  function dock(){
    if (!btn) return;
    var host = document.querySelector('shopify-chat');
    if (host && host.hasAttribute('open')) return; /* chat panel open: keep last spot */
    var o = chatOffsets();
    if (!o) return;
    var size = btn.offsetWidth || 46;
    var right = Math.round(o.right + o.ball / 2 - size / 2);
    var below = o.bottom - GAP - size;
    var bottom = Math.round(below >= 8 ? below : o.bottom + o.ball + GAP);
    var key = right + ',' + bottom;
    if (key === appliedKey) return;
    btn.style.right = right + 'px';
    btn.style.bottom = bottom + 'px';
    appliedKey = key;
  }

  function build(){
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gx-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5"/><path d="m5 12 7-7 7 7"/></svg>';
    btn.addEventListener('click', function () {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    var layer = document.createElement('div');
    layer.className = 'gx-layer';
    layer.appendChild(btn);
    document.body.appendChild(layer);
  }

  function sync(){
    if (!btn) return;
    var y = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
    btn.classList.toggle('is-on', y > SHOW_AT);
    dock();
  }

  function onScroll(){
    var now = Date.now();
    if (now - last < 100) return;
    last = now;
    sync();
  }

  function boot(){
    style(); build(); sync();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    setInterval(sync, 400); /* catches programmatic scrolls and the chat button loading late */
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
